// Copyright (c) Ping. All rights reserved.
//
// Base (non-macOS) resolution of the `PingDocReader` surface. Web renders
// docs inline in an <iframe>, so it never needs this native view — the
// placeholder + no-op staging helper keep the shared barrel and
// `MediaPreviewScreen` importable on the web bundle. Metro on desktop
// resolves `PingDocReader.macos.tsx` (PDFKit + NSTextView) instead.

import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';

export interface PingDocReaderProps {
  /** Local file path (or `file://` URL) to render. */
  readonly source: string;
  /** MIME — decides PDF vs text rendering on the native side. */
  readonly mime?: string | undefined;
  /** Filename — extension fallback when the MIME is generic. */
  readonly filename?: string | undefined;
  readonly style?: StyleProp<ViewStyle> | undefined;
  readonly testID?: string | undefined;
}

/** No-op placeholder off-macOS (see the `.macos` sibling for the real view). */
export function PingDocReader(props: PingDocReaderProps): React.ReactElement {
  const { style, testID } = props;
  return <View style={style} {...(testID !== undefined ? { testID } : {})} />;
}

/** True only when the native PDFKit/NSTextView reader is linked (false here). */
export function isPingDocReaderLinked(): boolean {
  return false;
}

/**
 * Stage decrypted document bytes to a temp file and resolve its path. No
 * native bridge off-macOS, so this always resolves `null`.
 */
export async function stageDocTempFile(
  _bytes: Uint8Array,
  _filename: string,
): Promise<string | null> {
  return null;
}
